import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";

const AdminNewsletter = () => {
  const [subscribers, setSubscribers] = useState([]);

  const load = async () => {
    const res = await api.get("/newsletter/subscribers");
    setSubscribers(res.data);
  };

  const remove = async (id) => {
    if (!window.confirm("Delete subscriber?")) return;

    try {
      await api.delete(`/newsletter/subscribers/${id}`);
      toast.success("Subscriber deleted");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  const exportCsv = () => {
    window.open(`${process.env.REACT_APP_API_URL}/newsletter/export`, "_blank");
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-black text-[#0b6b1d]">
          Newsletter Subscribers
        </h1>

        <button
          onClick={exportCsv}
          className="px-5 py-3 rounded-2xl bg-[#0b6b1d] text-white font-bold"
        >
          Export CSV
        </button>
      </div>

      <div className="bg-white rounded-3xl border overflow-hidden">
        {subscribers.map((sub) => (
          <div key={sub.id} className="p-4 border-b flex justify-between">
            <div>
              <p className="font-bold">{sub.name || "Subscriber"}</p>
              <p className="text-sm text-slate-500">{sub.email}</p>
            </div>

            <button onClick={() => remove(sub.id)} className="text-red-600">
              Delete
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdminNewsletter;